/* Generated. This file cannot be edited directly. Please check codegen.ts for configuration. */
// @ts-nocheck

import * as Apollo from '@apollo/client'

import { gql } from '@apollo/client'
import * as Types from '../../../../../graphql/src/lib/graphql/generated/types'

const defaultOptions = {} as const
export type FccBroadcastMessageDialogMutationVariables = Types.Exact<{
  message: Types.Scalars['String']['input']
  fleetIds: Array<Types.Scalars['ID']['input']> | Types.Scalars['ID']['input']
}>

export type FccBroadcastMessageDialogMutation = {
  __typename?: 'Mutation'
  fccBroadcastFleetShutdownMessage: any | null
}

export const FccBroadcastMessageDialogDocument = gql`
    mutation fccBroadcastMessageDialog($message: String!, $fleetIds: [ID!]!) {
  fccBroadcastFleetShutdownMessage(
    input: {fleetIds: $fleetIds, message: $message}
  )
}
    `
export type FccBroadcastMessageDialogMutationFn = Apollo.MutationFunction<
  FccBroadcastMessageDialogMutation,
  FccBroadcastMessageDialogMutationVariables
>

/**
 * __useFccBroadcastMessageDialogMutation__
 *
 * To run a mutation, you first call `useFccBroadcastMessageDialogMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFccBroadcastMessageDialogMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [fccBroadcastMessageDialogMutation, { data, loading, error }] = useFccBroadcastMessageDialogMutation({
 *   variables: {
 *      message: // value for 'message'
 *      fleetIds: // value for 'fleetIds'
 *   },
 * });
 */
export function useFccBroadcastMessageDialogMutation(
  baseOptions?: Apollo.MutationHookOptions<
    FccBroadcastMessageDialogMutation,
    FccBroadcastMessageDialogMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    FccBroadcastMessageDialogMutation,
    FccBroadcastMessageDialogMutationVariables
  >(FccBroadcastMessageDialogDocument, options)
}
export type FccBroadcastMessageDialogMutationHookResult = ReturnType<
  typeof useFccBroadcastMessageDialogMutation
>
export type FccBroadcastMessageDialogMutationResult =
  Apollo.MutationResult<FccBroadcastMessageDialogMutation>
export type FccBroadcastMessageDialogMutationOptions =
  Apollo.BaseMutationOptions<
    FccBroadcastMessageDialogMutation,
    FccBroadcastMessageDialogMutationVariables
  >
